import type {AppIconProps} from "../Icons.types";
import {getClassNames} from "../Icons.utils";
import styles from "./Num01.module.scss";

export const Num01Icon = (props: AppIconProps) => {
  const {className, ...rest} = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg {...rest} className={classNames} xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path fill="#000" d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z" opacity="0.6"></path>
      <path fill="#fff" d="M12.359 12.667c.329-.136.669-.289 1.02-.459.363-.181.714-.374 1.054-.578.34-.215.663-.436.969-.663.317-.238.6-.487.85-.748h1.768V22h-2.533v-8.483c-.34.227-.72.436-1.14.629-.418.181-.826.34-1.223.476l-.765-1.955z"></path>
    </svg>
  );
};
